import { createContext, useContext } from 'react';
import { DEFAULT_BROADCAST_QUALITY, SiteSettings } from '../../types';

export const useSiteSettingsContext = () => useContext(SiteSettingsContext);
export const SiteSettingsContext = createContext<SiteSettings>({
    isWhitelabel: false,
    isProduction: false,
    title: '',
    logoText: '',
    code: '',
    defaultLanguage: 'en',
    defaultBroadcastQuality: DEFAULT_BROADCAST_QUALITY,
    footerLinks: [],
    baseUrl: ''
});
